import { render } from "./Comingsoon.vue?vue&type=template&id=ff9d4862&scoped=true"
import script from "./Comingsoon.vue?vue&type=script&lang=js"
export * from "./Comingsoon.vue?vue&type=script&lang=js"

import "./Comingsoon.vue?vue&type=style&index=0&id=ff9d4862&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9d4862"]])

export default __exports__